import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '@app/core/store/app.state';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { selectUserRole } from '../store/userAuth/userAuth.selectors';
import { UserRoles } from '../enums/userRoles.enum';

@Injectable({
  providedIn: 'root'
})

export class UserRoleGuard implements CanActivate {
  constructor(
    private store: Store<AppState>,
    private router: Router
) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.store.select(selectUserRole).pipe(
      map((role) => {
        const roles = route.data['roles'] as Array<string>;
        const roleMatch = roles.includes(role);
        if (!roleMatch) {
            if (role === UserRoles.referralUser) this.router.navigate(['/ref-dashboard']);
            else if (role === UserRoles.workCompUser) this.router.navigate(['/wc-dashboard']);
            else if (role === UserRoles.adminUser) this.router.navigate(['/admin-dashboard']);
            else this.router.navigate(['/portal-login']);
        }
        return roleMatch;
      })
    );
  }
}